var render = function render(){
  var _vm$parse, _vm$lecture, _vm$lecture$video;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('v-fade-transition', [_c('v-overlay', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.ready,
      expression: "ready"
    }],
    attrs: {
      "absolute": ""
    }
  }, [_c('youtube', _vm._b({
    staticClass: "mb-n6",
    attrs: {
      "fitParent": ""
    },
    on: {
      "ready": _vm.check
    }
  }, 'youtube', {
    videoId: (_vm$parse = _vm.parse((_vm$lecture = _vm.lecture) === null || _vm$lecture === void 0 ? void 0 : (_vm$lecture$video = _vm$lecture.video) === null || _vm$lecture$video === void 0 ? void 0 : _vm$lecture$video.link)) === null || _vm$parse === void 0 ? void 0 : _vm$parse.id,
    width: _vm.width,
    height: _vm.height,
    playerVars: {
      autoplay: 1
    }
  }, false))], 1)], 1), _c('v-fade-transition', [_c('v-overlay', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.ready,
      expression: "!ready"
    }],
    attrs: {
      "absolute": "",
      "color": "transparent"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "size": "100",
      "width": "5",
      "color": "primary",
      "indeterminate": ""
    }
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }